module.exports = __webpack_public_path__ + "img/about_us_1.dd9fdcb6.png";